// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2KvIQ","boxTitle":"Qualiphy_boxTitle__2dpxG","box":"Qualiphy_box__21CzN","toggleWrap":"Qualiphy_toggleWrap__ob2i6"};